<template>
  <div class="guide-player-container">
    <v-toolbar density="compact" rounded>
      <v-icon v-show="isDraggable" ref="dragicon" color="font" data-testid="simulationToolbar.drag-icon"
        >mdi-drag</v-icon
      >
      <v-spacer />

      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <div v-bind="props">
            <v-btn-icon icon="mdi-play-circle" :disabled="isStarting || isRunning" class="px-sm-5 px-4" @click="play()">
            </v-btn-icon>
          </div>
        </template>
        <span>Start Simulation</span>
      </v-tooltip>

      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <div v-bind="props">
            <v-btn-icon
              icon="mdi-stop-circle"
              :disabled="!isRunning && !isStarting"
              class="px-sm-5 px-4"
              @click="stop()"
            >
            </v-btn-icon>
          </div>
        </template>
        <span>Stop Simulation</span>
      </v-tooltip>

      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <div v-bind="props">
            <v-btn-icon icon="mdi-restart" :disabled="!isRunning" class="px-sm-5 px-4" @click="restart()"> </v-btn-icon>
          </div>
        </template>
        <span>Restart Simulation</span>
      </v-tooltip>

      <v-spacer />
    </v-toolbar>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from "vue";
import { useDisplay } from "vuetify";

defineProps<{ isRunning: boolean; isStarting: boolean }>();
const emit = defineEmits(["playClicked", "stopClicked", "restartClicked"]);
const { smAndUp } = useDisplay();
const isDraggable = ref(false);
const dragicon = ref(null);

defineExpose({ dragicon });

onMounted(() => {
  isDraggable.value = smAndUp.value;
});

watch(smAndUp, (newVal: boolean) => {
  isDraggable.value = newVal;
});

function play() {
  emit("playClicked");
}

function stop() {
  emit("stopClicked");
}

function restart() {
  emit("restartClicked");
}
</script>
